export const territoryColors = [
    '#e53935', '#8e24aa', '#3949ab', '#039be5', '#00897b',
    '#43a047', '#fbc02d', '#fb8c00', '#6d4c41', '#d81b60',
    '#1e88e5', '#00acc1', '#7cb342', '#c0ca33', '#f4511e',
    '#5e35b1', '#3949ab', '#00838f', '#c62828', '#ad1457',
    '#1976d2', '#388e3c', '#ffa000', '#fdd835', '#ff7043',
    '#8d6e63', '#00bcd4', '#43a047', '#e64a19', '#7e57c2',
    '#0288d1', '#388e3c', '#fbc02d', '#c62828', '#ad1457',
    '#1976d2', '#388e3c'
];

export const getTerritoryColor = (territoryNumber: string): string => {
    const num = parseInt(territoryNumber);
    if (isNaN(num) || num <= 0) {
        return '#bdbdbd';
    }
    return territoryColors[(num - 1) % territoryColors.length];
}
